import { api } from './axios';
import type { PenaltyCatalogItem } from '../types/results';

export interface SavePenaltyCatalogRequest {
  disciplineId?: number | null;
  code: string;
  label: string;
  seconds: number;
  category: PenaltyCatalogItem['category'];
  sortOrder?: number;
  isActive?: boolean;
}

export const penaltyCatalogApi = {
  list: (competitionId: number, opts?: { disciplineId?: number; activeOnly?: boolean }) => {
    const params = new URLSearchParams();
    if (opts?.disciplineId != null) params.set('disciplineId', String(opts.disciplineId));
    if (opts?.activeOnly) params.set('activeOnly', 'true');
    const qs = params.toString();
    return api
      .get<PenaltyCatalogItem[]>(`/admin/competitions/${competitionId}/penalty-catalog${qs ? `?${qs}` : ''}`)
      .then((r) => r.data);
  },
  create: (competitionId: number, req: SavePenaltyCatalogRequest) =>
    api
      .post<PenaltyCatalogItem>(`/admin/competitions/${competitionId}/penalty-catalog`, req)
      .then((r) => r.data),
  update: (competitionId: number, id: number, req: SavePenaltyCatalogRequest) =>
    api
      .put<PenaltyCatalogItem>(`/admin/competitions/${competitionId}/penalty-catalog/${id}`, req)
      .then((r) => r.data),
  delete: (competitionId: number, id: number) =>
    api.delete(`/admin/competitions/${competitionId}/penalty-catalog/${id}`),
};
